import { css, keyframes } from "react-emotion";
import { flatWrapper, flexColumn } from "appStyles";

export const container = css`
  width: 100%;
`;

export const toggleBox = css`
  display: flex;
  justify-content: space-between;
  flex-direction: row;
  position: relative;
  width: 100%;
  height: 50px;
  cursor: pointer;
  z-index: 10;
  border-radius: 15px 15px 0px 0px;
`;

export const toggleBoxWrapper = css`
  width: 10%;
  height: 7%;
  left: 0;
  margin-left: 10px;
`;

export const hamburgerContainer = css`
  height: 40px;
  padding-top: 8px;
  width: 40px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  * {
    color: white;
    font-size: 2em;
  }
`;

export const line = css`
  width: 100%;
  height: 1.5px;
  border-radius: 0.4rem;
  background: white;
  transition: 0.25s;

  &:nth-child(1) {
    transform-origin: left;
  }
  &:nth-child(3) {
    transform-origin: left;
  }
`;

export const x = css`
  transition: 0.45s;

  &:nth-child(1) {
    transform: rotate(45deg);
  }

  &:nth-child(2) {
    opacity: 0;
    transition: 0.2s;
  }

  &:nth-child(3) {
    transform: rotate(-45deg);
  }
`;

const navFadeIn = keyframes`
  0% {  background: rgba(0,0,0,0); }
`;

export const fullPageNav = css`
  ${flatWrapper};
  ${flexColumn};
  padding-top: 5rem;
  animation: ${navFadeIn} 0.4s;
  font-size: 1.7rem;
  z-index: 10;
  border-radius: 15px;
`;

export const closedFullPageNav = css`
  background: rgba(0, 0, 0, 0) !important;
  opacity: 0;
  transition: 0.2s;
`;

const navSlideIn = keyframes`
  0% { transform: translateX(-15rem); }
`;

export const hamburgerNav = css`
  ${flatWrapper};
  ${flexColumn};
  padding-top: 5rem;
  font-size: 1.4rem;
  border-radius: 15px 0px 0px 15px;
  width: 60%;
  animation: ${navFadeIn} 0.4s;
  z-index: 10;
`;

export const closedHamburgerNav = css`
  background: rgba(0, 0, 0, 0) !important;
  opacity: 0;
  transition: 0.2s;
`;

export const navHeader = css`
  padding: 12.5px;
  font-size: 20px;
  color: white;
`;
